import React,{useState} from 'react'
import { useNavigate } from 'react-router-dom';

function CourseDetails() {
    let review = [1, 2, 3, 4]
    const [fixContainer, setfixContainer] = useState(false)
    const navigate = useNavigate();

    let handleClick=(event)=>{
        event.stopPropagation()
        navigate("/onlineCourses/course/Payment")
      }
      
  window.addEventListener("scroll", () => {
    let y = window.scrollY
    let div = document.querySelector('.maindiv')
    console.log(y);
    if (y > 300) {
        setfixContainer(true)
    }
    if (y < 200) {
        setfixContainer(false)
    }
    if (y >= (div.offset().top + div.outerHeight() - window.innerHeight)) {
        setfixContainer(false)
    }
})
  return (
    <div style={{ marginTop: "13%" }}>
     <div className="row flex-row-reverse w-100">
        <div className="col-md-3">
          <div className="p-3 white-3">
          <div className={`position-${fixContainer && "fixed py-5 pr-4  h-75"}  `} style={{ bottom: '15%', transition: ".5s" }}>
                        <div className="d-flex flex-column rounded p-3" style={{ backgroundColor: '#1A1A40', height: 'auto' }}>
                            <div className="my-2 d-flex justify-content-between">
                                <h4 className="white-2">Price</h4>
                                <h5 style={{textDecoration:"line-through"}}>INR 1500</h5>
                            </div>
                            <div className="my-2 d-flex justify-content-between">
                                <h4 className="white-3">save 15%</h4>
                                <h3>INR 1200</h3>
                            </div>
                            <a className="btn w-100  letter-dis-2  align-self-center" style={{ background: "#E65100" }} onClick={handleClick} >Buy now</a>
                        </div>
                        </div>
          </div>
        </div>
        <div className="col-md-7 white-2">
          <div className="d-flex"></div>
          <div className="d-flex justify-content-evenly">
            <img className="rounded  w-50  p-2 mb-2 border border-info" src={require('../../resource/global.webp')} alt="" />
            <div className="align-self-center">
              <div className=" py-1 m-1 ">
                <ion-icon name="share-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                <ion-icon name="heart-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                <ion-icon name="caret-down-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
              </div>
              <p className="white-2">17 Enrolled</p>
              <p className="white-2">35 Completed</p>
              <div className="review mt-3 white-3 " style={{ whiteSpace: "nowrap" }}>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                &#160;4.5
              </div>
            </div>
          </div>
          <h3 className="light-blue-text">
PHP for Beginners :
Build a Content Management System from Scratch with PHP and MySQL</h3>
          
              <div className="white-3 mt-5 pt-3">
                <h3 className=" white-2">What you'll learn</h3>
                <div className="border border-primary p-3 mb-2">
                <p>✔ Learn how to create a dynamic website using the most popular website programming language</p>
                <p>✔ Build a working CMS in PHP and MySQL from scratch </p>
                <p>✔ Learn how to secure your code</p>
                <p>✔ Learn how to write reusable, more maintainable code using programming standards</p>
                <p>✔ Learn how to structure your code using object-oriented programming techniques</p>
                <p>✔ Learn the theory but then put it into practice in a CMS project</p>
                <p>✔ Style your site using Bootstrap</p>
                <p>✔ How to integrate third-party code into your site</p>
                <p>✔ How to store data in a relational database and use this from PHP code</p>
                <p>✔ Learn all aspects of a basic web application in PHP: login, CRUD operations, sending emails, uploading files, Ajax</p>

                </div>
                <h3 className="white-2">Indicative Assessment</h3>
                <p>After every session student will get the assignment based on the following subjects as given below:</p>
                <ul>
                  <li>Working of Raspberry Pi and Sensor hat including some question.</li>
                  <li>Install of all the software with screenshot. .</li>
                  <li>Connection of all three layers. </li>
                  <li>configuration of Nifi and Mini Nifi with CDA including python code. </li>
                  <li>Results of all parameters with respect to time in form of graph.</li>

                </ul>

                <h3 className="white-2">Milestones/Workload</h3>
                <p>
                  Prerequisite you should know have like basic knowledge of Python language, docker, virtual box, zeppelin, phoenix, Raspberry pi sensor hat etc. If you don't know about it don't worry just look into all this on internet before you start this project with me.</p>
                <p>There will be no too much workload, just attend sessions and do you home work. And make sure you should submit all the assignment on time.</p>
                <ol>
                  <li>Submission of assignment.</li>
                  <li>Proper presentation and project report presentation.</li>
                  <li>Working knowledge of project.</li>
                </ol>

                <h3 className="white-2">Learning outcomes and student Eligibility</h3>
                <ol>
                  <li> Student of computer science engineering, electrical engineering, IT engineering.</li>
                  <li> Student of BCA (Bachelors in computer application) and MCA (masters in computer application)</li>
                  <li>Any other student who wish to work in IOT and agriculture etc.</li>
                </ol>
              </div>

              <div className="pt-3 mt-5">
              <h4>Course content</h4>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 1</h4>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 2</h4>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 3</h4>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                  <p className="p-3 white-3">✔ Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 4</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 5</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 6</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
              </div>


              <div className="pt-3 mt-5">
                {review.map((rev) => {
                  return <div className="co p-3 rounded m-3 deep-purple darken-4 shadow">
                    <div className="d-flex justify-content-between  align-items-end">
                      <div>
                        <img src={require(`../../resource/avater.png`)} width="60" height="60" className="p-1 mb-1 rounded-circle" style={{ background: "grey" }} alt="" />
                        <h5>Anita kumari</h5>
                      </div>
                      <div className="review white-3 " style={{ whiteSpace: "nowrap" }}>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        &#160;
                      </div>

                    </div>
                    <i className="white-3" >
                      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vero animi saepe pariatur beatae assumenda dolore reiciendis, eos omnis modi sunt tempore non. Rem, provident praesentium id, possimus, quisquam beatae cumque quis vero est saepe repudiandae? "
                    </i>
                  </div>

                })}
              </div>


              <div id="carouselExampleControls" class="carousel slide my-5 pt-3" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(45).webp"
                      alt="First slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(46).webp"
                      alt="Second slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(47).webp"
                      alt="Third slide" />
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
        </div>
      </div>
    </div>
  )
}

export default CourseDetails